function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoJobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 91,
    viewBox: "0 0 114 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M16.2924 60.7423C-3.3274 33.08 8.58705 14.425 16.9967 8.55529C29.8674 -1.24181 49.9833 -3.61108 60.7314 8.55529C88.3938 39.8675 111.062 18.9286 113.175 52.4821C115.288 86.0355 90.1227 89.8135 77.8923 90.2617C65.662 90.7099 40.8171 95.3203 16.2924 60.7423Z",
    fill: "#FFF6EB",
    style: {
      fill: "#FFF6EB",
      fill: "color(display-p3 1.0000 0.9651 0.9200)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 17288",
    d: "M77.4238 21.2693H80.1836V70.945H77.4238V21.2693Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 17288 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7344 19.5803H81.8721V72.634H75.7344V19.5803ZM77.4234 21.2693V70.945H80.1831V21.2693H77.4234Z",
    fill: "#052A75",
    style: {
      fill: "#052A75",
      fill: "color(display-p3 0.0196 0.1647 0.4588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 10 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.834 15.4068C25.834 9.88991 30.3063 5.4176 35.8232 5.4176H84.2963V7.46667H35.8232C31.438 7.46667 27.883 11.0216 27.883 15.4068V32.8238C27.883 33.3897 27.4243 33.8484 26.8585 33.8484C26.2927 33.8484 25.834 33.3897 25.834 32.8238V15.4068Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 10 (Stroke) (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9848 3.72864V9.15565H35.8227C32.3703 9.15565 29.5715 11.9544 29.5715 15.4068V32.8238C29.5715 34.3225 28.3567 35.5373 26.858 35.5373C25.3594 35.5373 24.1445 34.3225 24.1445 32.8238V15.4068C24.1445 8.95713 29.373 3.72864 35.8227 3.72864H85.9848ZM35.8227 5.41761C30.3058 5.41761 25.8335 9.88992 25.8335 15.4068V32.8238C25.8335 33.3897 26.2922 33.8484 26.858 33.8484C27.4239 33.8484 27.8826 33.3897 27.8826 32.8238V15.4068C27.8826 11.0216 31.4375 7.46668 35.8227 7.46668H84.2958V5.41761H35.8227Z",
    fill: "#052A75",
    style: {
      fill: "#052A75",
      fill: "color(display-p3 0.0196 0.1647 0.4588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 11 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9197 69.7082C26.4625 69.7082 26.0918 69.3375 26.0918 68.8802V50.6658C26.0918 50.2086 26.4625 49.8379 26.9197 49.8379C27.377 49.8379 27.7477 50.2086 27.7477 50.6658V68.8802C27.7477 69.3375 27.377 69.7082 26.9197 69.7082Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 11 (Stroke) (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4023 68.8809V50.6664C24.4023 49.2764 25.5292 48.1495 26.9192 48.1495C28.3093 48.1495 29.4362 49.2764 29.4362 50.6664V68.8809C29.4362 70.2709 28.3093 71.3978 26.9192 71.3978C25.5292 71.3978 24.4023 70.2709 24.4023 68.8809ZM27.7472 50.6664C27.7472 50.2092 27.3765 49.8385 26.9192 49.8385C26.462 49.8385 26.0913 50.2092 26.0913 50.6664C26.0913 50.6664 26.0913 50.6664 26.0913 50.6664V68.8809C26.0913 69.3381 26.462 69.7088 26.9192 69.7088C27.3765 69.7088 27.7472 69.3381 27.7472 68.8809V50.6664Z",
    fill: "#052A75",
    style: {
      fill: "#052A75",
      fill: "color(display-p3 0.0196 0.1647 0.4588)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6816 20.4653C71.6816 21.0312 71.2229 21.4899 70.6571 21.4899L36.7195 21.4899C36.1537 21.4899 35.695 21.0312 35.695 20.4653C35.695 19.8995 36.1537 19.4408 36.7195 19.4408L70.6571 19.4408C71.2229 19.4408 71.6816 19.8995 71.6816 20.4653Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 13 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0957 32.8241C68.0957 33.3899 67.637 33.8486 67.0712 33.8486H36.7194C36.1536 33.8486 35.6949 33.3899 35.6949 32.8241C35.6949 32.2583 36.1536 31.7996 36.7194 31.7996L67.0712 31.7996C67.637 31.7996 68.0957 32.2583 68.0957 32.8241Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.959 45.1185C51.959 45.6844 51.5003 46.1431 50.9345 46.1431H36.7191C36.1532 46.1431 35.6945 45.6844 35.6945 45.1185C35.6945 44.5527 36.1532 44.094 36.7191 44.094H50.9345C51.5003 44.094 51.959 44.5527 51.959 45.1185Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 15 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.959 57.4127C51.959 57.9785 51.5003 58.4372 50.9345 58.4372H36.7191C36.1532 58.4372 35.6945 57.9785 35.6945 57.4127C35.6945 56.8469 36.1532 56.3882 36.7191 56.3882H50.9345C51.5003 56.3882 51.959 56.8469 51.959 57.4127Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 16 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8585 39.4253C27.4243 39.4253 27.883 39.884 27.883 40.4498L27.883 43.6515C27.883 44.2173 27.4243 44.676 26.8585 44.676C26.2927 44.676 25.834 44.2173 25.834 43.6515L25.834 40.4498C25.834 39.884 26.2927 39.4253 26.8585 39.4253Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 16 (Stroke) (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.858 37.5934C28.3567 37.5934 29.5715 38.8083 29.5715 40.3069L29.5715 43.5086C29.5715 45.0072 28.3567 46.2221 26.858 46.2221C25.3594 46.2221 24.1445 45.0072 24.1445 43.5086L24.1445 40.3069C24.1445 38.8083 25.3594 37.5934 26.858 37.5934ZM27.8826 40.3069C27.8826 39.7411 27.4239 39.2824 26.858 39.2824C26.2922 39.2824 25.8335 39.7411 25.8335 40.3069L25.8335 43.5086C25.8335 44.0744 26.2922 44.5331 26.858 44.5331C27.4239 44.5331 27.8826 44.0744 27.8826 43.5086L27.8826 40.3069Z",
    fill: "#052A75",
    style: {
      fill: "#052A75",
      fill: "color(display-p3 0.0196 0.1647 0.4588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1399",
    d: "M93.9638 49.0241C93.9638 58.8555 85.9939 66.8254 76.1626 66.8254C66.3312 66.8254 58.3613 58.8555 58.3613 49.0241C58.3613 39.1928 66.3312 31.2229 76.1626 31.2229C85.9939 31.2229 93.9638 39.1928 93.9638 49.0241Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 17283",
    d: "M0.701172 64.5096L1.84313 63.3677L7.32452 68.8491L6.18257 69.991L0.701172 64.5096Z",
    fill: "#FD8F01",
    style: {
      fill: "#FD8F01",
      fill: "color(display-p3 0.9922 0.5608 0.0039)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 17284",
    d: "M7.32422 64.5096L6.18226 63.3677L0.700869 68.8491L1.84283 69.991L7.32422 64.5096Z",
    fill: "#FD8F01",
    style: {
      fill: "#FD8F01",
      fill: "color(display-p3 0.9922 0.5608 0.0039)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1402 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.876 23.6234C106.559 23.6234 107.113 23.0695 107.113 22.3863C107.113 21.703 106.559 21.1491 105.876 21.1491C105.193 21.1491 104.639 21.703 104.639 22.3863C104.639 23.0695 105.193 23.6234 105.876 23.6234ZM105.876 25.8441C107.785 25.8441 109.334 24.2959 109.334 22.3863C109.334 20.4766 107.785 18.9285 105.876 18.9285C103.966 18.9285 102.418 20.4766 102.418 22.3863C102.418 24.2959 103.966 25.8441 105.876 25.8441Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9674 72.6671C61.9674 70.8015 60.4551 69.2892 58.5895 69.2892H18.9815C17.1159 69.2892 15.6035 70.8015 15.6035 72.6671V76.1941C15.6035 80.3063 18.9371 83.6399 23.0493 83.6399H72.7361C76.8483 83.6399 80.1819 80.3063 80.1819 76.1941V70.6691C80.1819 69.907 79.5641 69.2892 78.802 69.2892C78.0399 69.2892 77.4221 69.907 77.4221 70.6691V73.9569C77.4221 77.7805 74.3224 80.8802 70.4988 80.8802H68.8907C65.0671 80.8802 61.9674 77.7805 61.9674 73.9569V72.6671Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9829 67.6002H58.591C61.3893 67.6002 63.6579 69.8688 63.6579 72.6671V73.9569C63.6579 76.8478 66.0014 79.1912 68.8922 79.1912H70.5003C73.3911 79.1912 75.7346 76.8478 75.7346 73.9569V70.6691C75.7346 68.9742 77.1086 67.6002 78.8035 67.6002C80.4984 67.6002 81.8724 68.9742 81.8724 70.6691V76.1942C81.8724 81.2392 77.7826 85.3289 72.7376 85.3289H23.0508C18.0058 85.3289 13.916 81.2392 13.916 76.1942V72.6671C13.916 69.8688 16.1846 67.6002 18.9829 67.6002ZM58.591 69.2892C60.4565 69.2892 61.9689 70.8016 61.9689 72.6671V73.9569C61.9689 77.7806 65.0686 80.8802 68.8922 80.8802H70.5003C74.3239 80.8802 77.4236 77.7806 77.4236 73.9569V70.6691C77.4236 69.907 78.0414 69.2892 78.8035 69.2892C79.5656 69.2892 80.1834 69.907 80.1834 70.6691V76.1942C80.1834 80.3064 76.8498 83.64 72.7376 83.64H23.0508C18.9386 83.64 15.605 80.3064 15.605 76.1942V72.6671C15.605 70.8016 17.1174 69.2892 18.9829 69.2892H58.591Z",
    fill: "#052A75",
    style: {
      fill: "#052A75",
      fill: "color(display-p3 0.0196 0.1647 0.4588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 17287",
    d: "M77.4238 13.3615C77.4238 8.88859 81.0498 5.26257 85.5228 5.26257H86.4354C90.9083 5.26257 94.5343 8.88859 94.5343 13.3615V21.2692H77.4238V13.3615Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 17287 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2228 22.9583H75.7344V13.3616C75.7344 7.95593 80.1166 3.57373 85.5223 3.57373H86.4349C91.8406 3.57373 96.2228 7.95592 96.2228 13.3616V22.9583ZM85.5223 5.26271C81.0494 5.26271 77.4234 8.88872 77.4234 13.3616V21.2693H94.5339V13.3616C94.5339 8.88872 90.9078 5.26271 86.4349 5.26271H85.5223Z",
    fill: "#052A75",
    style: {
      fill: "#052A75",
      fill: "color(display-p3 0.0196 0.1647 0.4588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1400",
    d: "M98.0623 45.7588C98.0623 55.8023 89.9204 63.9442 79.8768 63.9442C69.8333 63.9442 61.6914 55.8023 61.6914 45.7588C61.6914 35.7153 69.8333 27.5734 79.8768 27.5734C89.9204 27.5734 98.0623 35.7153 98.0623 45.7588Z",
    fill: "#FD8F01",
    style: {
      fill: "#FD8F01",
      fill: "color(display-p3 0.9922 0.5608 0.0039)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 17289",
    d: "M87.7969 58.2833L91.0569 55.0233L103.725 67.6913C104.625 68.5916 104.625 70.0511 103.725 70.9514Lnan nanL103.725 70.9514C102.825 71.8516 101.365 71.8516 100.465 70.9514L87.7969 58.2833Z",
    fill: "#FD8F01",
    style: {
      fill: "#FD8F01",
      fill: "color(display-p3 0.9922 0.5608 0.0039)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 17289 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4102 58.2833L91.0588 52.6347L104.921 66.497C106.481 68.0569 106.481 70.5858 104.921 72.1457C103.361 73.7055 100.832 73.7055 99.2725 72.1457L85.4102 58.2833ZM87.7987 58.2833L100.467 70.9514C101.367 71.8516 102.827 71.8516 103.727 70.9514C104.627 70.0511 104.627 68.5916 103.727 67.6913L91.0588 55.0233L87.7987 58.2833Z",
    fill: "#052A75",
    style: {
      fill: "#052A75",
      fill: "color(display-p3 0.0196 0.1647 0.4588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1401",
    d: "M96.2694 45.7588C96.2694 54.8122 88.9302 62.1513 79.8769 62.1513C70.8236 62.1513 63.4844 54.8122 63.4844 45.7588C63.4844 36.7055 70.8236 29.3663 79.8769 29.3663C88.9302 29.3663 96.2694 36.7055 96.2694 45.7588Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1401 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8769 60.4624C87.9974 60.4624 94.5804 53.8794 94.5804 45.7588C94.5804 37.6383 87.9974 31.0553 79.8769 31.0553C71.7563 31.0553 65.1734 37.6383 65.1734 45.7588C65.1734 53.8794 71.7563 60.4624 79.8769 60.4624ZM79.8769 62.1513C88.9302 62.1513 96.2694 54.8122 96.2694 45.7588C96.2694 36.7055 88.9302 29.3663 79.8769 29.3663C70.8236 29.3663 63.4844 36.7055 63.4844 45.7588C63.4844 54.8122 70.8236 62.1513 79.8769 62.1513Z",
    fill: "#052A75",
    style: {
      fill: "#052A75",
      fill: "color(display-p3 0.0196 0.1647 0.4588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 17283_2",
    d: "M74.1133 41.9825L76.1005 39.9953L85.6391 49.534L83.6519 51.5212L74.1133 41.9825Z",
    fill: "#FB554C",
    style: {
      fill: "#FB554C",
      fill: "color(display-p3 0.9843 0.3333 0.2980)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 17284_2",
    d: "M85.6387 41.9825L83.6515 39.9953L74.1128 49.534L76.1 51.5212L85.6387 41.9825Z",
    fill: "#FB554C",
    style: {
      fill: "#FB554C",
      fill: "color(display-p3 0.9843 0.3333 0.2980)",
      fillOpacity: 1
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11310_89113",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 5,
    width: 18,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 17290",
    d: "M77.4238 13.362C77.4238 8.88908 81.0498 5.26306 85.5228 5.26306H86.4354C90.9083 5.26306 94.5343 8.88908 94.5343 13.362V21.2697H77.4238V13.362Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11310_89113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1403",
    d: "M100.053 8.02276C100.053 12.9001 96.0992 16.854 91.2219 16.854C86.3445 16.854 82.3906 12.9001 82.3906 8.02276C82.3906 3.14541 86.3445 -0.808472 91.2219 -0.808472C96.0992 -0.808472 100.053 3.14541 100.053 8.02276Z",
    fill: "#FD8F01",
    style: {
      fill: "#FD8F01",
      fill: "color(display-p3 0.9922 0.5608 0.0039)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11310_89113",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 69,
    width: 66,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9694 72.6671C61.9694 70.8015 60.457 69.2892 58.5914 69.2892H18.9834C17.1178 69.2892 15.6055 70.8015 15.6055 72.6671V76.1941C15.6055 80.3063 18.9391 83.6399 23.0513 83.6399H72.7381C76.8503 83.6399 80.1839 80.3063 80.1839 76.1941V70.6691C80.1839 69.907 79.5661 69.2892 78.804 69.2892C78.0418 69.2892 77.424 69.907 77.424 70.6691V73.9569C77.424 77.7805 74.3244 80.8802 70.5008 80.8802H68.8927C65.069 80.8802 61.9694 77.7805 61.9694 73.9569V72.6671Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11310_89113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1404",
    d: "M35.4761 78.6725C35.4761 85.9885 29.5453 91.9194 22.2293 91.9194C14.9132 91.9194 8.98242 85.9885 8.98242 78.6725C8.98242 71.3565 14.9132 65.4257 22.2293 65.4257C29.5453 65.4257 35.4761 71.3565 35.4761 78.6725Z",
    fill: "#FD8F01",
    style: {
      fill: "#FD8F01",
      fill: "color(display-p3 0.9922 0.5608 0.0039)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 22396",
    d: "M77.4238 67.0811H80.1836V70.9447H77.4238V67.0811Z",
    fill: "#FCC354",
    style: {
      fill: "#FCC354",
      fill: "color(display-p3 0.9882 0.7647 0.3294)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoJobIcon);
export default __webpack_public_path__ + "static/media/no-job-icon.67a7a787f5a8a557e555295813fbd452.svg";
export { ForwardRef as ReactComponent };